var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FormFieldContext } from '../../FormField';
import { BodyText } from '../../BodyText';
import { Tooltip } from '../../Tooltip';
import { Button } from '../../Button';
import { Stack } from '../../Stack';
import { Icon } from '../../Icon';
import classnames from 'classnames';
import { toDateFormat } from '../../../utilities/dateFormat';
export const DateRangeTrigger = React.forwardRef((_a, ref) => {
    var { onKeyDown, className, disabled, error, onClick, open, placeholder, value, displayValue, size, required, onChange } = _a, rest = __rest(_a, ["onKeyDown", "className", "disabled", "error", "onClick", "open", "placeholder", "value", "displayValue", "size", "required", "onChange"]);
    const [valueRange, setValueRange] = React.useState(value);
    const TriggerClasses = classnames('Trigger', className, {
        'Trigger--open': open,
        'Trigger--error': error,
        'Trigger--disabled': disabled,
        [`Trigger--s-${size}`]: size,
    });
    const handleKey = (e) => {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    };
    const getShortLabel = () => {
        return (React.createElement("div", { className: "Trigger__shortLabel" },
            React.createElement(Icon, { name: "event", size: "20px" })));
    };
    const getArrow = () => open ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
    const valueString = displayValue !== null && displayValue !== void 0 ? displayValue : (valueRange.start &&
        valueRange.end &&
        `${toDateFormat.shortMonth(valueRange.start)} - ${toDateFormat.shortMonth(valueRange.end)}`);
    const getValues = () => {
        if (valueString)
            return (React.createElement(BodyText, { className: "Trigger__value" }, valueString));
        return (React.createElement(BodyText, { className: "Trigger__placeholder" }, placeholder));
    };
    const clearClick = (e) => {
        onChange({ start: null, end: null });
        setValueRange({ start: null, end: null });
        e.preventDefault();
        e.stopPropagation();
    };
    const getClearable = () => {
        if (!valueString || valueString.length === 0 || required)
            return;
        return (React.createElement(Tooltip, { text: disabled ? null : 'Clear selection', className: "d-f" },
            React.createElement(Button, { "aria-label": "clear selection", className: "Trigger__clear", fill: "subtle", disabled: disabled, iconName: "clear", onClick: clearClick, xsmall: true })));
    };
    const handleClick = (e) => {
        return onClick === undefined ? null : onClick(e);
    };
    const { labelFor: inputId, setFormFieldContext } = React.useContext(FormFieldContext);
    React.useEffect(() => {
        setFormFieldContext({
            inputRef: ref,
        });
        return () => setFormFieldContext({ inputRef: undefined });
    }, []); // eslint-disable-line
    React.useEffect(() => {
        setValueRange(value);
    }, [value]);
    return (React.createElement("div", Object.assign({ "aria-expanded": open, className: TriggerClasses, onClick: !disabled ? handleClick : undefined, tabIndex: disabled ? undefined : 0, onKeyDown: handleKey, id: inputId, ref: ref }, rest),
        React.createElement(Stack, null,
            getShortLabel(),
            getValues(),
            React.createElement(Stack, { className: "Trigger__controls", spacing: 1, alignItems: "flex-start" },
                getClearable(),
                React.createElement(Icon, { name: getArrow(), size: "16px", className: "Trigger__arrow" })))));
});
//# sourceMappingURL=DateRangeTrigger.js.map